import {Provider} from "@angular/core";
import {MODULE_VERSIONS} from "@fedelta-pos/data-client";
import {environment} from '../../environments/environment';

export class AppVersionHolder {
    public static version: string = environment.version;
}

export const WebOrderingAppVersion: Provider = {
    provide: MODULE_VERSIONS,
    useFactory: () => ({
        module: "web-order-app",
        get version(): string {
            return AppVersionHolder.version;
        }
    }),
    multi: true
};
